module.exports = __webpack_public_path__ + "quickpickpoollogo.24dd4db4fbe6a2741991.png";


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/img/quickpickpoollogo.png
// module id = ../../../../../src/img/quickpickpoollogo.png
// module chunks = styles